import React from 'react';

function DeleteData() {
  return (
    <div className="container p-4 card mt-4">
      <h1>Delete data</h1>
      <p>
        Our users can delete their user account and data will get deleted
        automatically. to delete user's account, to do this user must navigate
        to bottom third button of our app on navigation and press "Delete
        account" button.
      </p>
    </div>
  );
}

export default DeleteData;
